export default function getNavNodeProperties(currentPath, node) {
  const { childNodes, color, customUrl, id, promos, slug, title, type } = node;

  // customUrl is '' by default
  let href = customUrl;
  if (!href.length && type !== undefined && slug !== undefined) {
    href = `/cards/${type}/${slug}`;
  }

  const path = currentPath ? currentPath.slice() : [];
  path.push(node.title);
  const decoratedPromos = promos.map((element, index) => {
    element.path = path.slice();
    element.path.push('Promo Block ' + (index + 1));
    return element;
  });

  const children = childNodes.map(getNavNodeProperties.bind(undefined, path));

  if (type === 'section' && children.length > 1) {
    // DISCO-1064 clickable sections through a child.
    let allNode = {
      href,
      slug,
      childNodes: [],
      promos: [],
      title: `All ${title.toLowerCase()}`,
      path: [title, `All ${title.toLowerCase()}`],
      type: 'group',
    };

    children.push(allNode);
  }

  return {
    id,
    href,
    promos: decoratedPromos,
    slug,
    title,
    type,
    color,
    path,
    childNodes: children,
  };
}

export function getNavNodesProperties(nodes) {
  return nodes.map(node => getNavNodeProperties(null, node));
}
